import { c as _c } from "react/compiler-runtime";
import { type EmblaCarouselType } from 'embla-carousel';
import { useState } from 'react';
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { IconArrowBack } from '@/app/components/icons/ui-actions/icon-arrow-back';
import { IconArrowForward } from '@/app/components/icons/ui-actions/icon-arrow-forward';
import { type LifeCycleItem } from '@/app/components/sections/service/service-center/life-cycle/types';
import { type ServiceCenterOffersProps } from '@/app/components/sections/service/service-center/offers/types';
import { ServiceCenterOverviewCard } from '@/app/components/sections/service/service-center/overview/item';
import styles from '@/app/components/sections/service/service-center/overview/styles.module.css';
import { Sliders } from '@/app/components/sliders';
import { usePrevNextSlider } from '@/app/components/sliders/hooks/usePrevNextSlider';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface LifeCycleCarouselProps {
  items: LifeCycleItem[];
  testId: ServiceCenterOffersProps['testId'];
  eventName: ServiceCenterOffersProps['eventName'];
}
export const LifeCycleCarousel = t0 => {
  const $ = _c(23);
  const {
    testId,
    eventName,
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  const [emblaApi, setEmblaApi] = useState(null);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextSlider(emblaApi);
  const t3 = `${testId}-items`;
  let t4;
  if ($[2] !== t3) {
    t4 = createDataAttributes({
      test: t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== eventName || $[5] !== items || $[6] !== testId) {
    let t6;
    if ($[8] !== eventName || $[9] !== testId) {
      t6 = (item, index) => <div key={index} className={cn("group pl-4 lg:pl-6", "max-w-98 lg:max-w-full", styles.slide)} {...createDataAttributes({
        test: `${testId}-item-${index}`
      })}><ServiceCenterOverviewCard title={item.title} desc={item.description} image={{
          src: item.img.url,
          alt: item.title,
          width: 375,
          height: 250,
          aspectRatio: "aspect-3-2"
        }} eventName={eventName} testId={`${testId}-card`} cta={{
          href: item.button.url,
          children: "\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14",
          variant: "tertiary",
          iconAfter: <IconArrowForward />
        }} className="cursor-pointer bg-white" isHoverable={true} /></div>;
      $[8] = eventName;
      $[9] = testId;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = items.map(t6);
    $[4] = eventName;
    $[5] = items;
    $[6] = testId;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Sliders onEmblaInit={setEmblaApi} containerClassName="-ml-4 flex lg:-ml-6" loop={false} hidden={false} align="start" {...t4}>{t5}</Sliders>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== items.length || $[15] !== nextBtnDisabled || $[16] !== onNextButtonClick || $[17] !== onPrevButtonClick || $[18] !== prevBtnDisabled) {
    t7 = items.length > 1 && <ButtonGroup className="mt-10 hidden justify-end md:flex" {...createDataAttributes({
      test: "model-lineup-pagination"
    })}>{!(prevBtnDisabled && nextBtnDisabled) && <><Button aria-label="Previous" variant="primary" color="black" iconBefore={<IconArrowBack />} disabled={prevBtnDisabled} onClick={onPrevButtonClick} {...createDataAttributes({
          test: "previous-button"
        })} /><Button aria-label="Next" variant="primary" color="black" iconBefore={<IconArrowForward />} disabled={nextBtnDisabled} onClick={onNextButtonClick} {...createDataAttributes({
          test: "next-button"
        })} /></>}</ButtonGroup>;
    $[14] = items.length;
    $[15] = nextBtnDisabled;
    $[16] = onNextButtonClick;
    $[17] = onPrevButtonClick;
    $[18] = prevBtnDisabled;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};